import { useCallback } from "react";
import dayjs from "dayjs";
import ContractDetails from "../../fragments/contract-details";
import { useGetSalariesQuery } from "../../../../api/plamo-api";

function EmployeeContractDetails({ employee, employeeId, contractId }) {
  const { data: salaries } = useGetSalariesQuery({ f: JSON.stringify({ "employee.id": { c: "EQ", v: employeeId } })}) as any;

  const fillContract = useCallback((contractTemplate, lastContractDate, effectiveDate, validUntil) => {
    if(contractTemplate && employee) {
      const missingFields: { name: string, hint: string | undefined }[] = []

      const salaryPerHour = salaries?.items?.filter(s => (!s.startDate || dayjs(s.startDate).valueOf() <= dayjs(effectiveDate).valueOf()) && (!s.endDate || dayjs(s.endDate).valueOf() >= dayjs(effectiveDate).valueOf()))[0]?.salaryPerHour

      let limit;
      if(employee.jobType === "Minijob") {
        limit = 556;
      } else if(employee.jobType === "Midijob") {
        limit = 2000;
      }
      let worktimePerMonth = employee.workTimePerMonth;
      let worktimePerWeek = employee.workTimePerWeek;
      if(limit && salaryPerHour) {
         worktimePerMonth = Math.floor(limit / salaryPerHour * 4) / 4;
         worktimePerWeek = Math.floor(worktimePerMonth / 4.3 * 4) / 4;
      }

      const checkMissing = (v, fieldName: string, hint: string | undefined = undefined) => {
        if(!v && v !== '') {
          missingFields.push({ name: fieldName, hint });
          return "<span style=\"font-weight: bold; background-color: red;\">Wert fehlt!</span>"
        }
        return v;
      }

      const fill = (template: string) => template
        .replace(/{ANREDE}/g, () => checkMissing(employee.salutation ? (employee.salutation === 'M' ? 'Lieber' : 'Liebe') : null, "Anrede"))
        .replace(/{VORNAME}/g, () => checkMissing(employee.firstName, "Vorname"))
        .replace(/{NACHNAME}/g, () => checkMissing(employee.lastName, "Nachname"))
        .replace(/{STRASSE}/g, () => checkMissing(employee.addressStreet, "Straße"))
        .replace(/{HAUSNUMMER}/g, () => checkMissing(employee.addressHouseNumber, "Hausnummer"))
        .replace(/{PLZ}/g, () => checkMissing(employee.addressZipCode, "PLZ"))
        .replace(/{ORT}/g, () => checkMissing(employee.addressCity, "Ort"))
        .replace(/{VERTRAGSBEGINN}/g, () => checkMissing(effectiveDate ? dayjs(effectiveDate).format('DD.MM.YYYY') : null, "Vertragsbeginn"))
        .replace(/{GUELTIG_BIS}/g, () => checkMissing(validUntil ? dayjs(validUntil).format('DD.MM.YYYY') : null, "Gültig bis"))
        .replace(/{PROBEZEIT}/g, () => checkMissing(employee.dateOfProbation ? dayjs(employee.dateOfProbation).format('DD.MM.YYYY') : null, "Ende Probezeit"))
        .replace(/{BEFRISTUNG}/g, () => checkMissing(employee.limitation ? dayjs(employee.limitation).format('DD.MM.YYYY') : null, "Ende Befristung"))
        .replace(/{ARBEITSZEIT_WOECHENTL}/g, () => checkMissing(worktimePerWeek?.toString().replace('.', ','), "Wöchentl. Arbeitszeit", "Wurde kein Gehalt für den Zeitraum des Vertragsbeginns hinterlegt?"))
        .replace(/{ARBEITSZEIT_MONATL}/g, () => checkMissing(worktimePerMonth?.toString().replace('.', ','), "Monatl. Arbeitszeit", "Wurde kein Gehalt für den Zeitraum des Vertragsbeginns hinterlegt?"))
        .replace(/{STUNDENLOHN}/g, () => checkMissing(salaryPerHour?.toFixed(2).replace('.', ','), "Stundenlohn", "Wurde kein Gehalt für den Zeitraum des Vertragsbeginns hinterlegt?"))
        .replace(/{LETZTERVERTRAG}/g, () => checkMissing(lastContractDate ? dayjs(lastContractDate).format("DD.MM.YYYY") : null, "Letzter Vertrag", "Ggf. leeren Dummy-Vertrag mit Vertragstyp Unbekannt anlegen"))
        .replace(/{ERSATZVERTRAG}/g, () => checkMissing(lastContractDate ? `Beide Parteien sind sich darüber einig, dass der bisherige Arbeitsvertrag vom ${dayjs(lastContractDate).format("DD.MM.YYYY")} mit Abschluss dieses Arbeitsvertrages seine Gültigkeit verliert und mit Vertragsunterzeichnung durch folgende Regelungen vollumfänglich ersetzt wird. Die bisherige Ausübung der Tätigkeit seit dem ${dayjs(employee.dateOfEntry).format("DD.MM.YYYY")} wird hinsichtlich Probezeitregelung und Betriebszugehörigkeit angerechnet.` : '', "Ersatzvertrag"))
        .replace(/{DATUMEINTRITT}/g, () => checkMissing(employee.dateOfEntry ? dayjs(employee.dateOfEntry).format("DD.MM.YYYY") : null, "Eintritt"))

      const filledContract = fill(contractTemplate.text || "");
      const filledLetter = fill(contractTemplate.letterText || "")
        
        //.replace(/{UNTERSCHRIFTSFELD}/g, signatureTemplate)
      return { filledContract, filledLetter, missingFields };
    }
    return { filledContract: '', filledLetter: '', missingFields: [] };
  }, [employee, salaries])

  return (<ContractDetails 
    contractId={contractId} 
    contractObjectType="employee" 
    contractObjectId={employee?.id} 
    fillContract={fillContract} 
    signerFirstName={employee?.firstName} 
    signerLastName={employee?.lastName} 
    signerRole="Arbeitnehmer(in)" 
    navigationBasePath={`/employee/${employee?.id}/contracts`} 
    locationId={1} 
    address={{
      firstName: employee?.firstName,
      lastName: employee?.lastName,
      street: employee?.addressStreet,
      houseNumber: employee?.addressHouseNumber,
      zipCode: employee?.addressZipCode,
      city: employee?.addressCity
    }}
    showValidUntil={true}
    />)
}

export default EmployeeContractDetails;